import { datadogRum } from '@datadog/browser-rum';
import { datadogLogs } from '@datadog/browser-logs';
import {
  datadogApplicationId,
  datadogClientToken,
  datadogEnabled,
  datadogService,
  datadogSite,
  stage
} from '../config/baseConfig';

export class Datadog {
  private static initialized: boolean = false;
  // tslint:disable-next-line:no-empty
  private constructor() {}

  public static startMonitoring(): void {
    if (Datadog.initialized) {
      return;
    }
    Datadog.initialized = true;

    if (!datadogEnabled) {
      return;
    }

    const isProduction = stage === 'production';
    datadogRum.init({
      env: stage,
      service: datadogService,
      clientToken: datadogClientToken,
      site: datadogSite,
      applicationId: datadogApplicationId,
      sessionSampleRate: 100,
      sessionReplaySampleRate: isProduction ? 20 : 100,
      defaultPrivacyLevel: isProduction ? 'mask' : 'allow',
      trackResources: true,
      trackLongTasks: true,
      trackUserInteractions: true
    });
    datadogRum.startSessionReplayRecording();

    datadogLogs.init({
      env: stage,
      service: datadogService,
      clientToken: datadogClientToken,
      site: datadogSite,
      forwardErrorsToLogs: true,
      sessionSampleRate: 100
    });
  }
}
